var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.793 0.9162C10.9805 0.728729 11.2348 0.623413 11.5 0.623413C11.7652 0.623413 12.0195 0.728729 12.207 0.9162L16.207 4.9162C16.3945 5.10373 16.4998 5.35804 16.4998 5.6232C16.4998 5.88836 16.3945 6.14267 16.207 6.3302L12.207 10.3302C12.0184 10.5124 11.7658 10.6132 11.5036 10.6109C11.2414 10.6086 10.9906 10.5034 10.8052 10.318C10.6198 10.1326 10.5146 9.8818 10.5123 9.6196C10.51 9.3574 10.6108 9.1048 10.793 8.9162L13.086 6.6232H1.5C1.23478 6.6232 0.98043 6.51784 0.792893 6.33031C0.605357 6.14277 0.5 5.88842 0.5 5.6232C0.5 5.35798 0.605357 5.10363 0.792893 4.91609C0.98043 4.72856 1.23478 4.6232 1.5 4.6232H13.086L10.793 2.3302C10.6055 2.14267 10.5002 1.88836 10.5002 1.6232C10.5002 1.35804 10.6055 1.10373 10.793 0.9162V0.9162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWt);
export default __webpack_public_path__ + "static/media/arrow_right_wt.bd11f181ffe31ae6c97e0e6862ddea21.svg";
export { ForwardRef as ReactComponent };